module.exports = __webpack_public_path__ + "img/airplane_w.259ed0e3.svg";